import { useCallback } from 'react'
import { useSetAtom } from 'jotai'
import { modalStatusAtom } from 'store/atoms'
import { activityModalContainerId } from 'const/modalContainerId'

/**
 * Opens the Activity slide-in modal for a given account.
 *
 * Product-type agnostic: callers decide whether the Activity experience
 * should be shown as a modal (via this hook) or as a full-page navigation.
 * Any surface that needs to launch the Activity modal (Make A Payment,
 * Account Services, dashboard CTAs, etc.) should route through this hook so
 * the modal-launch logic lives in one place.
 */

interface OpenActivityOptions {
  accountId: string
  /**
   * Called synchronously before opening the Activity modal.
   * Use this to close any currently-open modal (e.g. Make A Payment) so it
   * unmounts before the Activity modal is triggered.
   */
  onBeforeOpenModal?: () => void
}

const useOpenActivity = () => {
  const updateModalStatus = useSetAtom(modalStatusAtom)

  return useCallback(
    ({ accountId, onBeforeOpenModal }: OpenActivityOptions) => {
      onBeforeOpenModal?.()
      updateModalStatus('Activity', activityModalContainerId(accountId))
    },
    [updateModalStatus]
  )
}

export default useOpenActivity
